export default __webpack_public_path__ + "static/media/team4.df224149.jpeg";